const toastCreate = function ({ parent, title = '', desc = '', varaint = 'info' }) {

  const h = parent.$createElement
  const vNodesTitle = h(
    'div',
    [
      h('b-icon', { props: { icon: iconB(varaint) } }),
      h('strong', { class: 'mx-2' }, title),
      h('span', desc)
    ],
  )
  parent.$bvToast.toast([], {
    title: [vNodesTitle],
    solid: true,
    variant: varaint,
    bodyClass: 'd-none',
  })
}

const iconB = (varaint) => {
  switch (varaint) {
    case 'success':
      return 'check-circle-fill';
    case 'danger':
      return 'x-circle-fill';
    default:
      return 'info-circle-fill'
  }
}

export {
  toastCreate
}
export default {
  toastCreate
}